import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const LocationPanel = () => {
  const [Location, setLocation] = useState([]);
  const [NearPoint, setNearPoint] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_location_list"
      );
      setLocation(response.data.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_all_points"
      );
      setNearPoint(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_loc_point",
        { loc_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1") {
        setNearPoint((prevUser) =>
          prevUser.filter((user) => user.loc_id !== userId)
        );
        toast.error("Data Deleted Successfully!");
        navigate("/Location/Address");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Data.");
    }
  };

  return (
    <div className="container mt-5">
      <div className="locaton-section">
{Location.map((data, index) => {
  return (
    <div className="container mb-4" key={index}>
      <Link to={`/Edit-Location/${data.location_id}`} className="d-flex justify-content-end p-2">
        <button className="btn btn-primary btn-sm me-1">
          <i className="fa-regular fa-pen-to-square text-white"></i>
        </button>
      </Link>
      <p>{data.location_address}</p>
    </div>
  );
})}


      </div>
      <div className="container mt-5">
        <div className="add-btn">
          <Link to="/add-location">
            <button className="btn btn-success text-white">
              Add Near Places
            </button>
          </Link>
        </div>
        <table className="table table-bordered table-striped">
          <thead className="">
            <tr>
              <th colSpan="4" className=" text-center bg-white fs-4 text-black">
                Near Places Table
              </th>
            </tr>
            <tr>
              <th className="text-white text-center table-custom">Near Place Image</th>
              <th className="text-white text-center table-custom">Title</th>
              <th className="text-white text-center table-custom">Description</th>
              <th className="text-white text-center table-custom">Actions</th>
            </tr>
          </thead>
          <tbody>
            {NearPoint.map((Data, index) => (
              <tr key={index}>
                <td>
                  <img
                    src={`https://cyberathon.com/silverapartment/${Data.loc_image}`}
                    alt="Banner"
                    style={{ width: "100px", height: "auto" }}
                  />
                </td>
                <td>
                  <strong>{Data.loc_heading}</strong>
                </td>
                <td>{Data.loc_description}</td>
                <td>
                  <Link to={`/View/Location/Address/${Data.loc_id}`}>
                    <button className="btn btn-info btn-sm me-1">
                      <i className="fa-regular fa-eye text-white "></i>
                    </button>
                  </Link>
                  <Link to={`/Edit/Location/Address/${Data.loc_id}`}>
                    <button className="btn btn-primary btn-sm me-1">
                      <i className="fa-regular fa-pen-to-square text-white "></i>
                    </button>
                  </Link>
                  <button
                    className="btn btn-danger btn-sm me-1"
                    onClick={() => deleteUser(Data.loc_id)}
                  >
                    <i className="fa-regular fa-trash-can text-white "></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


export const EditAddress = () => {
  const [AddressInfoUser, setAddressInfoUser] = useState({
    location_id: "",
    location_address: "",
    location_map: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  // ✅ Handle input change & normalize Google Maps URL
  const changeHandler = (e) => {
    const { name, value } = e.target;
    let newValue = value.trim();

    if (name === "location_map") {
      // If iframe HTML is pasted, extract the src value
      const iframeMatch = newValue.match(/src="([^"]+)"/);
      if (iframeMatch) {
        newValue = iframeMatch[1];
      }

      // If only pb part is given, prepend Google Maps embed base URL
      if (!newValue.startsWith("http") && newValue.length > 0) {
        newValue = `https://www.google.com/maps/embed?pb=${newValue}`;
      }
    }

    setAddressInfoUser((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  // ✅ Fetch existing location data
  useEffect(() => {
    const AddressInfoData = async () => {
      try {
        const response = await axios.get(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_location_by_id`,
          { params: { location_id: id } }
        );

        if (response.data?.data) {
          setAddressInfoUser(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };
    AddressInfoData();
  }, [id]);

  // ✅ Submit form data
const submitForm = async (e) => {
  e.preventDefault();

  let fixedMap = AddressInfoUser.location_map.trim();

  // Extract from iframe if needed
  const iframeMatch = fixedMap.match(/src="([^"]+)"/);
  if (iframeMatch) fixedMap = iframeMatch[1];

  // Prepend if only pb code
  if (!fixedMap.startsWith("http") && fixedMap.length > 0) {
    fixedMap = `https://www.google.com/maps/embed?pb=${fixedMap}`;
  }

  const formData = new FormData();
  formData.append("location_id", AddressInfoUser.location_id);
  formData.append("location_address", AddressInfoUser.location_address);
  formData.append("location_map", fixedMap); // ✅ now always valid

  try {
    const response = await axios.post(
      `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_location`,
      formData
    );

    if (response.data.success === "1") {
      toast.info(response.data.message || "Data Updated Successfully!");
      navigate("/Location/Address");
    } else {
      toast.error(response.data.message || "Update failed!");
    }
  } catch (error) {
    console.error("Error updating location:", error);
    toast.error("There was an error updating the location.");
  }
};


  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header justify-content-center table-custom">
              <h5 className="modal-title text-white">Edit</h5>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Address</label>
                <textarea
                  rows={5}
                  type="text"
                  value={AddressInfoUser.location_address || ""}
                  onChange={changeHandler}
                  className="form-control"
                  name="location_address"
                />
              </div>

              {/* <div className="form-group">
                <label>Location Map</label>
                <input
                  type="text"
                  value={AddressInfoUser.location_map || ""}
                  onChange={changeHandler}
                  className="form-control"
                  name="location_map"
                  placeholder="Paste Google Maps embed link, pb code, or iframe HTML"
                />
                <small className="text-muted">
                  Example embed URL: https://www.google.com/maps/embed?pb=...
                </small>
              </div>

         
              {AddressInfoUser.location_map && (
                <div style={{ marginTop: "10px" }}>
                  <iframe
                    src={AddressInfoUser.location_map}
                    width="100%"
                    height="250"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              )} */}
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                Update
              </button>
              <Link to="/Location/Address">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};


export const NearPointAdd = () => {
  const users = {
    loc_heading: "",
    loc_description: "",
  };
  const [NewPointUser, setNewPointUser] = useState(users);
  const [NewPointImage, setNewPointImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setNewPointUser({ ...NewPointUser, [name]: value });
    console.log(NewPointUser);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNewPointImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("loc_heading", NewPointUser.loc_heading);
    formData.append("loc_description", NewPointUser.loc_description);

    if (NewPointImage) {
      formData.append("loc_image", NewPointImage);
    }
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_loc_point",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.status === true) {
        toast.success("Data Added Successfully!");
        setNewPointImage(null);
        setPreviewImage(null);
        navigate("/Location/Address");
      } else {
        toast.error(response.data.error || "Failed to add Near Point");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-header table-custom text-white">
          <h4 className="mb-0 text-white text-center">Add Data</h4>
        </div>

        <div className="card-body">
          <form className="row g-3" onSubmit={submitForm}>
            <div className="col-md-6">
              <label htmlFor="image" className="form-label">
                Image
              </label>
              <input
                type="file"
                className="form-control"
                id="loc_image"
                accept="image/*"
                onChange={handleImageChange}
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  className="mt-2"
                  style={{ width: "100px", height: "auto" }}
                />
              )}
            </div>

            <div className="col-md-6">
              <label htmlFor="loc_heading" className="form-label">
                Title
              </label>
              <input
                type="text"
                className="form-control"
                id="loc_heading"
                name="loc_heading"
                placeholder="Enter Title"
                value={NewPointUser.loc_heading}
                onChange={inputHandler}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="loc_description" className="form-label">
                Description
              </label>
              <input
                type="text"
                className="form-control"
                id="loc_description"
                name="loc_description"
                placeholder="Enter Description"
                value={NewPointUser.loc_description}
                onChange={inputHandler}
              />
            </div>

            <div className="col-12 d-flex justify-content-end">
              <button type="submit" className="btn btn-success" style={{height:"40px"}}>
                Add Near Point
              </button>
              <div className="mb-3 ps-2">
                <Link to="/Location/Address" className="btn btn-secondary">
                  Back
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const EditNearPoint = () => {
  const [NewPointImage, setNewPointImage] = useState(null);
  const [NearpointUser, setNearpointUser] = useState({
    loc_heading: "",
    loc_description: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNearpointUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const NearpointInfoData = async () => {
      try {
        const response = await axios.post(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_loc_point_by_id`,
          {
            loc_id: id,
          }
        );
        setNearpointUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    NearpointInfoData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("loc_id", id);
    formData.append("loc_heading", NearpointUser.loc_heading);
    formData.append("loc_description", NearpointUser.loc_description);

    if (NewPointImage) {
      formData.append("loc_image", NewPointImage);
    }

    try {
      const response = await axios.post(
        `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_loc_point`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success === "1") {
        toast.success(response.data.message || "Data updated successfully");
        navigate("/Location/Address");
      } else {
        toast.error(response.data.message || "Failed to update Near Point");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        paddingBottom: 50,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header table-custom text-white justify-content-center">
              <h5 className="modal-title">Edit Near Point</h5>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">
                  Image{" "}
                  <span className="text-danger">
                    (Image must be at least 90x100%)
                  </span>
                </label>
                <input
                  type="file"
                  id="loc_image"
                  className="form-control"
                  onChange={(e) => setNewPointImage(e.target.files[0])}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  value={NearpointUser.loc_heading}
                  onChange={changeHandler}
                  className="form-control"
                  id="loc_heading"
                  name="loc_heading"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">loc_description</label>
                <textarea
                  rows={5}
                  type="text"
                  value={NearpointUser.loc_description}
                  onChange={changeHandler}
                  className="form-control"
                  id="loc_description"
                  name="loc_description"
                />
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                Update
              </button>
              <Link to="/Location/Address">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const ViewNearPoint = () => {
  const [NearPointUser, setNearPointUser] = useState({
    loc_image: "",
    loc_heading: "",
    loc_description: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const NearPointData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_loc_point_by_id",
          {
            loc_id: id,
          }
        );
        setNearPointUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    NearPointData();
  }, [id]);

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between">
      <h2 className="mb-4">View Address</h2>
      <Link to="/Location/Address" className="btn m-2">
        <button type="button" className="back-btn">Back</button>
      </Link>
</div>
      <div className="card p-3">
        <div>
        <img
          src={`https://cyberathon.com/silverapartment/${NearPointUser.loc_image}`}
          alt="Banner"
          className="img-fluid rounded"
          style={{ maxWidth: "400px" }}
        />
      <h3 className="mt-3">{NearPointUser.loc_heading}</h3>
      <p>{NearPointUser.loc_description}</p>
      </div>
      </div>
    </div>
  );
};
